import "./about1.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function About1() {
    return (
        <div className="about-row">
            <div className="about-two-block">
                <div className="about-two-block_inner">
                    <span className="about-two_block-icon"><i aria-hidden="true" class="fas fa-rocket"></i></span>
                    <h5 className="about-two_block-heading">Experience</h5>
                    <div className="about-two_block-text">20+ Years Experience in Designing & Development in Various Technology</div>
                </div>
            </div>
            <div className="about-two-block">
                <div className="about-two-block_inner">
                    <span className="about-two_block-icon">   <i className="fas fa-chalkboard"></i></span>
                    <h5 className="about-two_block-heading">Projects</h5>
                    <div className="about-two_block-text">More than 5000 Projects we have already delivered to our clients Worldwide</div>
                </div>
            </div>
            <div className="about-two-block">
                <div className="about-two-block_inner">
                    <span className="about-two_block-icon"><i aria-hidden="true" class="fas fa-users"></i></span>
                    <h5 className="about-two_block-heading">Clients</h5>
                    <div className="about-two_block-text">400+ Clients in INDIA & 800+ Clients Network Worldwide with 360° Support.</div>
                </div>
            </div>
            <div className="about-two-block">
                <div className="about-two-block_inner">
                    <span className="about-two_block-icon"><i className="fas fa-user-plus"></i>
                    </span>
                    <h5 className="about-two_block-heading">Team</h5>
                    <div className="about-two_block-text">20+ Developer & Designer Team for Serve Various Technology.</div>
                </div>
            </div>
        </div>
    );
}
